export const selectCartItems = ({ cart }) => cart.cartItems;
export const selectPaymentMethod = ({ cart }) => cart.paymentMethod;
export const selectPayPalOrderConfig = ({ cart }) => cart.paypalOrderConfig;
export const selectStripeOrderConfig = ({ cart }) => cart.stripeOrderConfig;
export const selectIsValidToPay = ({ cart }) => cart.isValidToPay;
